
import AWS, { CloudFormation } from "aws-sdk";
import { key_details } from "../../api/apiHandler";


export const fetchKeyDetails = async () => {
  try {
    const response = await key_details();
    console.log("API Response:", response);

    if (response?.code === "1" && response?.data?.S3_details) {
      console.log("Extracted S3 Details:", response.data.S3_details);
      return response?.data?.S3_details;
    }
  } catch (error) {
    console.error("Error fetching key details:", error);
  }
  return null; // Ensure it returns null instead of undefined
};


export const uploadImageOnAWS = async (file, folder) => {
  console.log('file :', file);

  const credentials = await fetchKeyDetails();

  if (!credentials || !credentials.S3_access_key || !credentials.S3_secret_key || !credentials.S3_region || !credentials.S3_Name) {
    console.error("AWS credentials are missing or invalid!", credentials);
    throw new Error("Failed to retrieve AWS credentials");
  }

  AWS.config.update({
    region: credentials.S3_region,
    accessKeyId: credentials.S3_access_key,
    secretAccessKey: credentials.S3_secret_key,
  });

  // console.log(file);
  const s3 = new AWS.S3();
  const fileName = `${new Date().getTime()}${file.type?.split("/")?.[0] == "image" ? ".png" : file.type?.split("/")?.[0] == "video" ? ".mp4" : file?.name}`;
  const params = {
    Bucket: "studentscholars",
    Key: `${folder}/${fileName}`,
    Body: file,
    ACL: "public-read-write",
  };
  console.log('params :', params);

  try {
    await s3.upload(params).promise();
    console.log("Filename", fileName);
    return fileName;
  } catch (error) {
    console.log("error in S3 upload :", error);
    throw error;
  }
};  